<template>
  <div class="search-box">
    <nav-icon name="search" :size="15" class="s-ic" />
    <input
      type="text"
      :value="modelValue"
      :placeholder="placeholder"
      :aria-label="placeholder"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <button v-if="modelValue" class="clr" @click="$emit('update:modelValue', '')" aria-label="Clear search">
      <nav-icon name="close" :size="13" />
    </button>
  </div>
</template>

<script>
import NavIcon from '../NavIcon.vue'

export default {
  name: 'SearchBox',
  components: { NavIcon },
  props: {
    modelValue: { type: String, default: '' },
    placeholder: { type: String, default: 'Search…' }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
.search-box { position: relative; display: flex; align-items: center; width: 240px; max-width: 100%; }
.s-ic { position: absolute; left: 11px; color: var(--text-secondary); pointer-events: none; }
.search-box input {
  width: 100%;
  padding: 9px 32px 9px 34px;
  background: var(--field-bg);
  border: 1px solid var(--panel-border);
  border-radius: var(--radius);
  color: var(--text-primary);
  font-size: 13px;
}
.search-box input::placeholder { color: var(--text-secondary); }
.search-box input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(var(--primary-rgb), 0.2);
}
.clr {
  position: absolute; right: 7px;
  display: flex; align-items: center; justify-content: center;
  width: 22px; height: 22px;
  background: none; border: none; color: var(--text-secondary); cursor: pointer; border-radius: 6px;
}
.clr:hover { color: var(--text-primary); background: var(--hover-bg); }

@media (max-width: 1024px) {
  .search-box { width: 100%; }
}
</style>
